//import "bootstrap/dist/css/bootstrap.css";
import "./custom.scss"
import './App.css';
import { Col, Row, Container, Card } from "react-bootstrap";
import { useEffect, useState, React } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import dayjs from "dayjs"; // 👈 Importato dayjs per il calcolo delle date
import sondaggioCompletato from './immagini/sondaggi/sondaggioCompletato2.jpg'
import PaginaGrazie from "./componenti/Utente/Sondaggi/Risposte/PaginaGrazie";

//componenti
import Cruscotto from "./componenti/Admin/Cruscotto/Cruscotto";
import LogoComune from "./componenti/Admin/LogoComune";
import Sidebar from "./componenti/Admin/Sidebar"
import Petizioni from "./componenti/Admin/Petizioni/Petizioni";
import Referendum from "./componenti/Admin/Referendum/Referendum";
import BilanciPartecipativi from "./componenti/Admin/BilanciPartecipativi/BilanciPartecipativi";
import Segnalazioni from "./componenti/Admin/Segnalazioni/Segnalazioni";
import ImpostazioniGenerali from "./componenti/Admin/ImpostazioniGenerali/ImpostazioniGenerali"
import Sondaggi from "./componenti/Admin/Sondaggi/Sondaggi";
import CaricamentoLogin from "./componenti/CaricamentoLogin";
import { AxiosInterceptor } from "./componenti/Utilities/AuthTokenUtils";

import Homepage from "./componenti/Utente/Homepage/Homepage";
import NavbarUtente from "./componenti/Utente/Homepage/NavbarUtente";
import EsploraPetizioni from "./componenti/Utente/Petizioni/EsploraPetizioni";
import CreaPetizione from "./componenti/Utente/Petizioni/CreaPetizione";
import PaginaPetizione from "./componenti/Utente/Petizioni/PaginaPetizione";
import CreaReferendum from "./componenti/Utente/Referendum/CreaReferendum";
import EsploraReferendum from "./componenti/Utente/Referendum/EsploraReferendum";
import PaginaReferendum from "./componenti/Utente/Referendum/PaginaReferendum";
import EsploraBilanci from "./componenti/Utente/Bilancio/EsploraBilanci";
import PaginaBilancio from "./componenti/Utente/Bilancio/PaginaBilancio";
import PaginaProposta from "./componenti/Utente/Bilancio/PaginaProposta";
import CreaProposta from "./componenti/Utente/Bilancio/CreaProposta";
import Footer from "./componenti/Utente/Homepage/Footer";
import Login from "./componenti/Utente/Login/Login";
import EsploraSondaggi from "./componenti/Utente/Sondaggi/EsploraSondaggi";
import PaginaSondaggio from "./componenti/Utente/Sondaggi/PaginaSondaggio";
import RispondiSondaggio from "./componenti/Utente/Sondaggi/RispondiSondaggio";

//servizi
import ComuneService from "./services/ComuneService";
import PartecipanteService from "./services/PartecipanteService";
import EsploraSegnalazioni from "./componenti/Utente/Segnalazioni/EsploraSegnalazioni";
import CreaSegnalazione from "./componenti/Utente/Segnalazioni/CreaSegnalazione";
import PaginaSegnalazione from "./componenti/Utente/Segnalazioni/PaginaSegnalazione";
import SPIDcard from "./componenti/Utente/Login/SPIDcard";
import Scrolltotop from "./componenti/Utilities/ScrollToTop";
import PaginaNonTrovata from "./componenti/Utente/Error/PaginaNonTrovata"
import Partecipanti from "./componenti/Admin/Partecipanti/Partecipanti";

import VerificaToken from "./componenti/Utente/VerificaToken";
import LoginOk from "./componenti/Utente/Login/LoginOk";
import PaginaErroreGenerico from "./componenti/Utente/Error/PaginaErroreGenerico";
import EsploraIniziative from "./componenti/Utente/Iniziative/EsploraIniziative";
import PaginaIniziativa from "./componenti/Utente/Iniziative/PaginaIniziativa";
import CreaProgetto from "./componenti/Utente/Iniziative/CreaProgetto";
import PaginaProgetto from "./componenti/Utente/Iniziative/PaginaProgetto";
import Iniziative from "./componenti/Admin/Iniziative/Iniziative";

export default function App() {
  let [comId, setComId] = useState(52)
  let [errore, setErrore] = useState(false)

  let [comune, setComune] = useState({})
  let [ricaricaComune, setRicaricaComune] = useState(true)
  let [partecipante, setPartecipante] = useState({})

  //stato che governa quale tab è attiva nella pagina del bilancio e delle iniziative
  const [activeTab, setActiveTab] = useState("informazioni")

  // per permettere il ricaricamento del referendum dopo la fase di voto, è necessario mantenere uno stato
  // che ha il compito di forzare l'esecuzione della use effect nel componente PaginaReferendum
  const [ricaricaReferendum, setRicaricaReferendum] = useState(true)

  //STATI necessari alla sidebar e ai tab widget per cambiare la tab attiva
  const [tabAttivaPetizioni, setTabAttivaPetizioni] = useState("petizioni")
  const [tabAttivaReferendum, setTabAttivaReferendum] = useState("referenda")
  const [tabAttivaSegnalazioni, setTabAttivaSegnalazioni] = useState("segnalazioni")
  const [tabAttivaBilanci, setTabAttivaBilanci] = useState("bilanciPartecipativi")
  const [tabAttivaIniziative, setTabAttivaIniziative] = useState("iniziative")
  const [tabAttivaImpostazioni, setTabAttivaImpostazioni] = useState("impostazioni-comune")
  const [tabAttivaSondaggi, setTabAttivaSondaggi] = useState("sondaggi")

  //STATI mostrano la tabella con tutti gli elementi (parte admin)
  let [mostraTabellaPetizioni, setMostraTabellaPetizioni] = useState(true)
  let [mostraTabellaReferendum, setMostraTabellaReferendum] = useState(true)
  let [mostraTabellaSegnalazioni, setMostraTabellaSegnalazioni] = useState(true)
  let [mostraTabellaBilanci, setMostraTabellaBilanci] = useState(true)
  let [mostraTabellaIniziative, setMostraTabellaIniziative] = useState(true)
  let [mostraTabellaSondaggi, setMostraTabellaSondaggi] = useState(true)

  const [caricaPartecipante, setCaricaPartecipante] = useState(true)
  const [pageReady, setPageReady] = useState(false)

  //nuovo stato per la MFA
  const [OTPVerifyId, setOTPVerifyId] = useState(null);

  AxiosInterceptor()

  function aggiornaRicaricaPartecipante() {
    setCaricaPartecipante(true)
  }

  //RICAVA COMID DA HTTP HEADER (in ambiente prod)
  useEffect(() => {
    if (process.env.REACT_APP_FIND_HEADER === 'true') {
      ComuneService.header()
        .then((response) => {
          if (!response.status === 200) {
            setErrore(true)
          } else {
            setComId(response.data)
          }
        })
        .catch((error) => {
          console.log(error)
          setErrore(true);
        });
    }
  }, []);

  useEffect(() => {
    if (caricaPartecipante) {
      const partecipante = sessionStorage.getItem("partecipante");

      if (partecipante) {
        let cfChiaro = "";

        try {
          const base64Str = partecipante.replace(/[^A-Za-z0-9+/=]/g, '');
          cfChiaro = atob(base64Str);
        } catch (e) {
          console.error('Errore durante la decodifica Base64:', e);
          return;
        }

        PartecipanteService.findByCf(cfChiaro)
          .then(res => {
            setPartecipante(res.data);
          })
          .catch(err => {
            console.log("Errore al caricamento del partecipante", err);
          })
          .finally(() => {
            setCaricaPartecipante(false);
          });
      } else {
        setCaricaPartecipante(false);
      }
    }
  }, [caricaPartecipante]);

  useEffect(() => {
    if (ricaricaComune && comId !== null) {
      setPageReady(false)
      ComuneService.getComune(comId)
        .then(res => {
          setComune(res.data)
          setPageReady(true)
        })
        .catch(err => {
          setComune({})
          setErrore(true)
        })
        .finally(() => setRicaricaComune(false))
    }
  }, [ricaricaComune, comId])


 const isMaintenanceActive = () => {
    if (!comune || !comune.comDataManutenzione) return false;

    const today = dayjs().startOf('day');
    const maintenanceDate = dayjs(comune.comDataManutenzione).startOf('day');
    
    // Ritorna true solo se la data di oggi coincide esattamente con quella impostata
    return maintenanceDate.isValid() && maintenanceDate.isSame(today);
  };

  return (
    errore ?
      <PaginaErroreGenerico />
      :
      <Router>
        <Scrolltotop />
        {pageReady && (
          // 👇 CONTROLLO SPOSTATO QUI IN ALTO: Blocca tutto l'applicativo! 👇
          isMaintenanceActive() ? (
            // 🛑 Schermata di blocco GLOBALE per Manutenzione in corso
            <>
              <NavbarUtente comune={comune} partecipante={partecipante} setPartecipante={setPartecipante} />
              <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
                  <Card className="text-center p-5 shadow-lg" style={{ maxWidth: "600px", borderTop: "5px solid #ffc107" }}>
                      <Card.Body>
                          <h1 className="display-4 text-warning mb-3">Lavori in Corso</h1>
                          <h4 className="mb-4">Il sistema è attualmente in manutenzione.</h4>
                          <p className="lead text-muted">
                              {comune.comDescManutenzione || "Stiamo effettuando un aggiornamento del sistema. Torneremo online a breve."}
                          </p>
                      </Card.Body>
                  </Card>
              </Container>
              <Footer />
            </>
          ) : (
            // ✅ SISTEMA ATTIVO: Tutte le rotte normali
            <Routes>
              <Route exact path="/login" element={<Login comune={comune} aggiornaRicaricaPartecipante={aggiornaRicaricaPartecipante} />} />
              <Route exact path="/verifica-token" element={<VerificaToken aggiornaRicaricaPartecipante={aggiornaRicaricaPartecipante} />} />
              
              {/* PARTE UTENTE */}
              <Route path="/*" element={
                <>
                  <NavbarUtente comune={comune} partecipante={partecipante} setPartecipante={setPartecipante} />
                  <Routes>
                    <Route path="/caricamento-login" element={<CaricamentoLogin aggiornaRicaricaPartecipante={aggiornaRicaricaPartecipante} />} />
                    <Route path="/loginok" element={<LoginOk />} />
                    <Route path="/pagina-di-errore" element={<PaginaErroreGenerico />} />
                    <Route path="/spid/*" element={<SPIDcard setPartecipante={setPartecipante} comune={comune} />} />
                    
                    <Route exact path="/" element={<Homepage comune={comune} partecipante={partecipante} setCaricaPartecipante={setCaricaPartecipante} />} />

                    {/* MODULO PETIZIONI */}
                    <Route exact path="/esplora-petizioni" element={<EsploraPetizioni comune={comune} partecipante={partecipante} />} />
                    <Route exact path="/crea-petizione" element={<CreaPetizione comune={comune} partecipante={partecipante} />} />
                    <Route exact path="/petizione" element={<PaginaPetizione comune={comune} partecipante={partecipante} />} />

                    {/* MODULO REFERENDUM */}
                    <Route exact path="/esplora-referendum" element={<EsploraReferendum comune={comune} partecipante={partecipante} />} />
                    <Route exact path="/crea-referendum" element={<CreaReferendum comune={comune} partecipante={partecipante} />} />
                    <Route exact path="/referendum" element={<PaginaReferendum comune={comune} partecipante={partecipante} ricaricaReferendum={ricaricaReferendum} setRicaricaReferendum={setRicaricaReferendum} />} />

                    {/* MODULO BILANCI */}
                    <Route exact path="/esplora-bilanci-partecipativi" element={<EsploraBilanci comune={comune} setActiveTab={setActiveTab} partecipante={partecipante} />} />
                    <Route exact path="/bilancio" element={<PaginaBilancio comune={comune} activeTab={activeTab} setActiveTab={setActiveTab} partecipante={partecipante} />} />
                    <Route exact path="/proposta" element={<PaginaProposta comune={comune} partecipante={partecipante} />} />
                    <Route exact path="/crea-proposta" element={<CreaProposta comune={comune} partecipante={partecipante} />} />

                    {/* MODULO SEGNALAZIONI */}
                    <Route exact path="/esplora-segnalazioni" element={<EsploraSegnalazioni comune={comune} partecipante={partecipante} />} />
                    <Route exact path="/crea-segnalazione" element={<CreaSegnalazione comune={comune} partecipante={partecipante} />} />
                    <Route exact path="/segnalazione" element={<PaginaSegnalazione comune={comune} partecipante={partecipante} />} />

                    {/* MODULO INIZIATIVE */}
                    <Route exact path="/esplora-iniziative" element={<EsploraIniziative comune={comune} setActiveTab={setActiveTab} partecipante={partecipante} />} />
                    <Route exact path="/iniziativa" element={<PaginaIniziativa comune={comune} activeTab={activeTab} setActiveTab={setActiveTab} partecipante={partecipante} />} />
                    <Route exact path="/progetto" element={<PaginaProgetto comune={comune} partecipante={partecipante} />} />
                    <Route exact path="/crea-progetto" element={<CreaProgetto comune={comune} partecipante={partecipante} />} />

                    {/* MODULO SONDAGGI */}
                    <Route exact path="/esplora-sondaggi" element={<EsploraSondaggi comune={comune} setActiveTab={setActiveTab} partecipante={partecipante} />} />
                    <Route exact path="/sondaggio" element={<PaginaSondaggio comune={comune} activeTab={activeTab} setActiveTab={setActiveTab} partecipante={partecipante} />} />
                    <Route exact path="/rispondi-sondaggio" element={<RispondiSondaggio comune={comune} partecipante={partecipante} />} />

                    <Route exact path="/pagina-non-trovata" element={<PaginaNonTrovata />} />
                    <Route
                      path="/sondaggio-gia-completato"
                      element={
                        <PaginaGrazie
                          titolo="Hai già risposto!"
                          sottotitolo="Grazie per la tua partecipazione. Hai già completato questo sondaggio."
                          bottone="Torna alla Home"
                          immagine={sondaggioCompletato}
                        />
                      }
                    />
                  </Routes>
                  <Footer />
                </>
              } />

              {/* PARTE ADMIN */}
              <Route path="/admin/*" element={
                <div className="d-flex flex-column vh-100 admin-layout-wrapper">
                  <LogoComune comune={comune} />
                  <Container fluid className="flex-grow-1 px-0 ">
                    <Row className="g-0">
                      <Sidebar 
                        comune={comune} 
                        ricaricaComune={ricaricaComune} 
                        partecipante={partecipante}
                        setTabAttivaPetizioni={setTabAttivaPetizioni}
                        setMostraTabellaPetizioni={setMostraTabellaPetizioni}
                        setTabAttivaReferendum={setTabAttivaReferendum}
                        setMostraTabellaReferendum={setMostraTabellaReferendum}
                        setTabAttivaSegnalazioni={setTabAttivaSegnalazioni}
                        setMostraTabellaSegnalazioni={setMostraTabellaSegnalazioni}
                        setTabAttivaBilanci={setTabAttivaBilanci}
                        setMostraTabellaBilanci={setMostraTabellaBilanci}
                        setTabAttivaIniziative={setTabAttivaIniziative}
                        setMostraTabellaIniziative={setMostraTabellaIniziative}
                        setTabAttivaSondaggi={setTabAttivaSondaggi}
                        setMostraTabellaSondaggi={setMostraTabellaSondaggi}
                        setTabAttivaImpostazioni={setTabAttivaImpostazioni} 
                      />
                      <Col className="p-3 main-content-col mt-5" style={{ overflowY: 'auto', height: '100%' }}>
                        <Routes>
                          <Route path="" element={<Navigate to="/admin/cruscotto" />} />
                          <Route path="/cruscotto" element={<Cruscotto comune={comune} partecipante={partecipante} />} />
                          <Route path="/petizioni" element={<Petizioni comune={comune} setRicaricaComune={setRicaricaComune} tabAttivaPetizioni={tabAttivaPetizioni} setTabAttivaPetizioni={setTabAttivaPetizioni} mostraTabella={mostraTabellaPetizioni} setMostraTabella={setMostraTabellaPetizioni} partecipante={partecipante} />} />
                          <Route exact path="/referendum" element={<Referendum comune={comune} setRicaricaComune={setRicaricaComune} tabAttivaReferendum={tabAttivaReferendum} setTabAttivaReferendum={setTabAttivaReferendum} mostraTabella={mostraTabellaReferendum} setMostraTabella={setMostraTabellaReferendum} partecipante={partecipante} />} />
                          <Route exact path="/segnalazioni" element={<Segnalazioni comune={comune} setRicaricaComune={setRicaricaComune} tabAttivaSegnalazioni={tabAttivaSegnalazioni} setTabAttivaSegnalazioni={setTabAttivaSegnalazioni} mostraTabella={mostraTabellaSegnalazioni} setMostraTabella={setMostraTabellaSegnalazioni} partecipante={partecipante} />} />
                          <Route exact path="/bilanci-partecipativi" element={<BilanciPartecipativi comune={comune} setRicaricaComune={setRicaricaComune} tabAttivaBilanci={tabAttivaBilanci} setTabAttivaBilanci={setTabAttivaBilanci} mostraTabella={mostraTabellaBilanci} setMostraTabella={setMostraTabellaBilanci} partecipante={partecipante} />} />
                          <Route exact path="/iniziative" element={<Iniziative comune={comune} setRicaricaComune={setRicaricaComune} tabAttivaIniziative={tabAttivaIniziative} setTabAttivaIniziative={setTabAttivaIniziative} mostraTabella={mostraTabellaIniziative} setMostraTabella={setMostraTabellaIniziative} partecipante={partecipante} />} />
                          <Route exact path="/sondaggi" element={<Sondaggi comune={comune} setRicaricaComune={setRicaricaComune} tabAttivaSondaggi={tabAttivaSondaggi} setTabAttivaSondaggi={setTabAttivaSondaggi} mostraTabella={mostraTabellaSondaggi} setMostraTabella={setMostraTabellaSondaggi} partecipante={partecipante} />} />
                          <Route exact path="/impostazioni-generali" element={<ImpostazioniGenerali comune={comune} setRicaricaComune={setRicaricaComune} tabAttivaImpostazioni={tabAttivaImpostazioni} setTabAttivaImpostazioni={setTabAttivaImpostazioni} partecipante={partecipante} />} />
                          <Route exact path="/partecipanti" element={<Partecipanti comune={comune} setRicaricaComune={setRicaricaComune} partecipante={partecipante} />} />
                        </Routes>
                      </Col>
                    </Row>
                  </Container>
                </div>
              } />
            </Routes>
          )
        )}
      </Router>
  );
}